import { OrderAction, OrderStatus } from 'global/Securities/types/transaction';
import { ShareOrderStatus, ShareOrderType } from 'typings/api/shareTradeShare';

export const orderStatusRemap = {
  [OrderStatus.Open]: ShareOrderStatus.Open,
  [OrderStatus.Amended]: ShareOrderStatus.Amend,
  [OrderStatus.Match]: ShareOrderStatus.Match,
  [OrderStatus.Withdrawn]: ShareOrderStatus.Cancel,
};

export const orderActionRemap = {
  [OrderAction.Buy]: ShareOrderType.Buy,
  [OrderAction.Sell]: ShareOrderType.Sell,
};
